import React, {useState} from 'react'
import {Grid, Typography, Box, makeStyles, Button, Container} from '@material-ui/core'

import SuhaBubble from '../Suha/SuhaBubble'
import SuhaBare from '../Suha/SuhaBare'
import BackButton from '../Common/BackButton'

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '2vh 5vw',
    },
    footer: {
        backgroundColor: "#256081",
        minHeight: '300px',
        color: "white",
        justifyContent: "flex-end",
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        padding: "20px 20px 20px",
        marginBottom: 20
    },
    nextButton: {
        backgroundColor: '#256081',
        color: 'white',
        borderRadius: '10px',
        padding: "10px 10px",
        marginTop: theme.spacing(3),
        // display: 'flex',
        margin: 'auto',
        fontSize: '1.5em',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
        textTransform: "none"
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    logo: {
        maxWidth: '80vw',
    },
    body1: {
        colorTextPrimary: {
            color: 'red',
            backgroundColor: 'red',
        },
    },
    suha: {
        margin: '5vh',
        maxWidth: '33vw',
    },
    gridContainer: {},
}))

interface Screen {
    name: string
    text: string[]
    buttons: string
    suha_position: string
    next_slide: string
    show_back_button: boolean
}

interface InfoProps {
    screens: any[]
    handleNext: any
    handlePrev: any
}

export default function Intro(props: InfoProps) {
    const classes = useStyles()
    const [screenNumber, setScreenNumber] = useState(0)

    let screens = props.screens as Screen[]

    const nextButton = (fx: any) => {
        return (
            <React.Fragment>
                <div className={classes.buttons}>
                    <Button
                        fullWidth={true}
                        variant="contained"
                        onClick={fx}
                        className={classes.nextButton}
                    >
                        Next
                    </Button>
                </div>
            </React.Fragment>
        )
    }

    const handleNext = () => {
        if (screenNumber < screens.length - 1) {
            setScreenNumber(screenNumber + 1)
            return
        }
        props.handleNext()
    }

    const handlePrev = () => {
        if (screenNumber > 0) {
            setScreenNumber(screenNumber - 1)
            return
        }
        props.handlePrev()
    }

    const isComplete = () => {
        return screenNumber === screens.length
    }

    const items = (index) => {
        let items: any = []
        if (isComplete()) {
            return items
        }

        //TODO no side effects with map
        if (index != null) {
            let value = screens[screenNumber].text[index]
            items.push(
                <Grid item>
                    <Typography>
                        <div dangerouslySetInnerHTML={{__html: value}}></div>
                    </Typography>
                    <br/>
                </Grid>
            )
        } else {
            screens[screenNumber].text.map((value, idx) => {
                items.push(
                    <Grid item key={idx}>
                        <Typography>
                            <div dangerouslySetInnerHTML={{__html: value}}></div>
                        </Typography>
                        <br/>
                    </Grid>
                )
                return ``
            })
        }
        return items
    }

    return (
        <>
            {screenNumber == 0 ?
                <>
                    <Container className={classes.footer}>
                        <Grid container justifyContent={"center"} justify={"center"}  alignItems={"center"}>
                            <Grid item sm={8} xs={12} container justifyContent={"center"} justify={"center"}  alignItems={"center"}>
                                <Grid item xs={7}>
                                    {items(0)}
                                </Grid>
                                <Grid item xs={5}>
                                    <SuhaBare position={screenNumber}/>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Container>
                    <Grid container className={classes.root} justifyContent={"center"} justify={"center"} alignItems={"center"}>
                        <Grid item sm={7} xs={12} style={{minHeight: 215}}>
                            {items(1)}
                        </Grid>
                        <Grid item sm={7} xs={12}>
                            {nextButton(handleNext)}
                        </Grid>
                    </Grid>
                </> :
                <Grid container direction={"row"} className={classes.root} justifyContent={"center"} justify={"center"}  alignItems={"flex-start"}>
                    <Grid item xs={3} container direction={"column"}  alignItems={"flex-start"} justify={"center"} justifyContent={"center"} >
                        <Grid item xs={12} >
                            <BackButton
                                show_button={screens[screenNumber].show_back_button}
                                handleClick={handlePrev}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <SuhaBubble position={screenNumber}/>
                    </Grid>
                    <Grid item xs={3}>

                    </Grid>
                    <Grid item sm={7} xs={12} container style={{minHeight: 400}}>
                        {items(null)}
                    </Grid>
                    <Grid item sm={7} xs={12}>{nextButton(handleNext)}</Grid>
                </Grid>
            }
        </>
    )
}
